var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('BaseHeadline',{attrs:{"level":"1"}},[_vm._v("moin.")]),_c('Divider'),_c('BaseHeadline',{attrs:{"level":"2"}},[_vm._v(" powerful communication."),_c('br'),_vm._v(" for you. and your customers. ")]),_c('BaseButton',{attrs:{"inverted":"","text":"Get in touch!","link":"imprint"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }